import { render, staticRenderFns } from "./pass-dialog.vue?vue&type=template&id=2cfb6487&scoped=true&"
import script from "./pass-dialog.vue?vue&type=script&lang=js&"
export * from "./pass-dialog.vue?vue&type=script&lang=js&"
import style0 from "./pass-dialog.vue?vue&type=style&index=0&id=2cfb6487&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cfb6487",
  null
  
)

export default component.exports